import { useRef, useEffect, useState } from "react";
import Pagination from "../../../../Components/Pagination";
import Button from "../../../../Core/Button/Button";
import GetIcon from "../../../../utils/Icon";
import { useGetLiabilityAccountsByCompanyQuery, useGetAllcompanyQuery } from "../../../../store/api/supplier";

const Table = ({ setSelectedCompanyAccounts,initialData }) => {
    // console.log(initialData,"initialData")
    const [company, setCompany] = useState([]);
    const [rows, setRows] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showDropdownIndex, setShowDropdownIndex] = useState(null);
    const [focusedCell, setFocusedCell] = useState({ rowIndex: null, field: null });
    const [selectedCompanyForApi, setSelectedCompanyForApi] = useState(null);
    
    const tableRef = useRef();
    const dropdownRef = useRef();
    const [rowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    const { data: companyData } = useGetAllcompanyQuery();
    const { data: accountsData } = useGetLiabilityAccountsByCompanyQuery(selectedCompanyForApi, {
        skip: !selectedCompanyForApi
    });

    useEffect(() => {
        if (initialData && initialData.length > 0) {
            setRows(initialData.map(item => ({
                company: item.company,
                default_account: item.account
            })));
        } else {
            setRows([createNewRow()]);
        }
    }, [initialData]);

    useEffect(() => {
        if (companyData) {
            setCompany(companyData?.data || []);
        }
    }, [companyData]);

    useEffect(() => {
        if (accountsData && focusedCell.rowIndex !== null) {
            const updatedRows = [...rows];
            updatedRows[focusedCell.rowIndex] = {
                ...updatedRows[focusedCell.rowIndex],
                default_account: accountsData.data[0]?.name || 'No account found'
            };
            setRows(updatedRows);
        }
    }, [accountsData, focusedCell.rowIndex]);

    useEffect(() => {
        const transformedData = rows
            .filter(row => row.company && row.default_account && row.default_account !== 'Loading...')
            .map(row => ({
                company: row.company,
                account: row.default_account
            }));
        
        setSelectedCompanyAccounts(transformedData);
    }, [rows, setSelectedCompanyAccounts]);


    const createNewRow = () => ({
        company: "",
        default_account: ""
    });

    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = rows.slice(indexOfFirstRow, indexOfLastRow);
    const isAllSelected = rows.length > 0 && selectedRows.length === rows.length;

    const handleSelectAll = (e) => {
        setSelectedRows(e.target.checked ? rows.map((_, index) => index) : []);
    };

    const toggleRowSelection = (index) => {
        setSelectedRows(prev =>
            prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
        );
    };

    const updateRow = (index, field, value) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = value;
        setRows(updatedRows);
    };

    const handleAddRow = () => {
        const newRows = [...rows, createNewRow()];
        setRows(newRows);
        const lastPage = Math.ceil(newRows.length / rowsPerPage);
        if (currentPage !== lastPage) setCurrentPage(lastPage);
    };

    const handleDeleteSelectedRows = () => {
        const updatedRows = rows.filter((_, idx) => !selectedRows.includes(idx));
        setRows(updatedRows);
        setSelectedRows([]);
        const lastPage = Math.ceil(updatedRows.length / rowsPerPage);
        if (currentPage > lastPage) setCurrentPage(lastPage);
    };

    const handleCompanySelect = (rowIndex, selectedCompany) => {
        const updatedRows = [...rows];
        updatedRows[rowIndex] = {
            company: selectedCompany.name,
            default_account: 'Loading...'
        };
        setRows(updatedRows);
        setFocusedCell({ rowIndex, field: 'company' });
        setSelectedCompanyForApi(selectedCompany.name);
        setShowDropdownIndex(null);
    };

    return (
        <div className="table-container">
            <table className="table table-bordered mb-1" ref={tableRef}>
                <thead className="tableHead1">
                    <tr>
                   
                        <th style={{ width: '4%', textAlign: 'center' }}>S.No</th>
                        <th style={{ width: '350px' }}>Company</th>
                        <th style={{ width: '350px' }}>Default Account</th>
                        <th style={{ width: '250px', textAlign: 'center' }}>
                            <GetIcon iconName="PiSlidersHorizontalBold" size={12} />
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {currentRows.map((row, index) => {
                        const globalIndex = indexOfFirstRow + index;
                        return (
                            <tr key={globalIndex}>
                       
                             <td style={{ textAlign: "center" }}><span style={{ fontSize: '0.8rem' }}
                                >{globalIndex + 1}</span></td>
                                <td className="p-0 position-relative">
                                    <input
                                        type="text"
                                        disabled
                                        style={{ textAlign: "center",fontSize:'0.8rem' }}
                                        className="form-control tableinput noborder"
                                        value={row.company}
                                        onFocus={() => {
                                            setShowDropdownIndex(globalIndex);
                                            setFocusedCell({ rowIndex: globalIndex, field: 'company' });
                                        }}
                                        onBlur={() => setTimeout(() => setShowDropdownIndex(null), 200)}
                                        onChange={(e) => updateRow(globalIndex, "company", e.target.value)}
                                    />
                                    {showDropdownIndex === globalIndex && (
                                        <div
                                            ref={dropdownRef}
                                            className="dropdown-menu show"
                                            style={{
                                                width: '100%',
                                                maxHeight: '200px',
                                                overflowY: 'auto'
                                            }}
                                        >
                                            {company
                                                .filter(c => c.name.toLowerCase().includes(row.company?.toLowerCase()))
                                                .map((comp) => (
                                                    <button
                                                        key={comp.id}
                                                        style={{ textAlign: "center" }}
                                                        className="dropdown-item"
                                                        type="button"
                                                        onClick={() => handleCompanySelect(globalIndex, comp)}
                                                    >
                                                        {comp.name}
                                                    </button>
                                                ))}
                                        </div>
                                    )}
                                </td>
                                <td className="p-0">
                                    <input
                                        type="text"
                                        disabled
                                        style={{ textAlign: "center" ,fontSize:'0.8rem' }}
                                        className="form-control tableinput noborder"
                                        value={row.default_account}
                                        readOnly
                                    />
                                </td>
                                <td className="p-0">
                                    <GetIcon iconName="MdOutlineEdit" size={13}  style={{ marginTop: '6px' }} />
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>

            <div className="d-flex pb-2 justify-content-between align-items-center">
                <div className="d-flex" style={{ gap: '4px' }}>
                    {selectedRows.length > 0 && (
                        <Button
                            onClick={handleDeleteSelectedRows}
                            className="customdeletebtn"
                            iconName="MdDeleteOutline"
                        >
                            Delete
                        </Button>
                    )}
                   
                </div>

                {rows.length > 10 && (
                    <>
                        <div className="d-flex align-items-center centerpagination">
                            <Pagination
                                setCurrentPage={setCurrentPage}
                                currentPage={currentPage}
                                pageSize={rowsPerPage}
                                totalrecords={rows.length}
                            />
                        </div>
                        <div className="d-flex">
                            <span className="px-2" style={{ color: '#270B79' }}>
                                Showing {indexOfFirstRow + 1} to {Math.min(indexOfLastRow, rows.length)} of {rows.length} entries
                            </span>
                        </div>
                    </>
                )}
            </div>
        </div>
    );
};

export default Table;